<div class="dialog-header">
  {{ "kopetro.customerForm.submitted" | translate }}
</div>

<mat-divider></mat-divider>

<div class="dialog-content">
  <div>{{ "kopetro.customerForm.submittedDesc" | translate }}</div>
  <div>{{ "kopetro.customerForm.submittedDesc2" | translate }}</div>
</div>

<div class="dialog-footer">
  <button mat-flat-button type="button" class="btn" (click)="goTo()">
    {{ "kopetro.customerForm.view" | translate }}
  </button>
</div>
